import * as styles from './index.module.scss';

import { useContext } from 'react';

import { SiteContext } from '@/contexts/site-context';
import { cleanHeadline, formatPhoneNumber, swapPhone } from '@/helpers/helpers';
import { trackEvent } from '@/helpers/helpers_tracking';
import HeroBullets from '@/components/HeroBullets';
import LocationLabel from '@/components/LocationLabel';
import Stars from '@/components/Stars';
import PhoneIcon from 'svgs/phone.svg';
import { QueryParamElement } from '../QueryParamElement';

const defaultHeadline = 'Get Home Repair Help Fast!';
const defaultSubheadline = 'Get connected to a local pro right when you need one.';

const HeroCategoryLight = (props) => {
  const [site] = useContext(SiteContext);

  const headline = props.category?.headline || defaultHeadline;
  const subheadline = swapPhone(cleanHeadline(props.category?.subheadline, site.location) || defaultSubheadline, site.phone_number || props.category?.phone_number);

  return (
    <div className={styles['hero-category-container']}>
      <div className={`${styles['container']} container`}>
        <LocationLabel />
        <QueryParamElement element="h1" queryParam="h1" fallbackText={headline} />
        <QueryParamElement element="h2" queryParam="h2" fallbackText={subheadline} injectFallback />
        <div className={styles['category-trigger-container']}>
          <label>Call now for a quote</label>
          <a
            href={`tel:${site.phone_number}`}
            className={`button large ${styles['cta-trigger']}`}
            onClick={() => {
              try {
                trackEvent({
                  event_type: 'conversion',
                  event_category: 'phone',
                  event_action: 'click'
                });
                console.debug('event tracked');
              } catch (e) {
                console.debug('event not tracked', e);
              }
            }}
          >
            <PhoneIcon /> {formatPhoneNumber(site.phone_number)}
          </a>
        </div>
        <Stars theme="dark-yellow" />
        <h3>Top Rated Service</h3>
        <HeroBullets category={props.category} theme="light" />
      </div>
    </div>
  );
};

export default HeroCategoryLight;
